export default __webpack_public_path__ + "static/media/icon-truck.6a10e7c2.svg";